/* Created by Hannah Green for ES-169 on 6/14/2021 */
import React, { useState } from "react";
import styled from "styled-components";
import TextArea from "components/textarea";
import {DetailsTable} from "./inspection_details_table";
import { ReviewButton, SubmitButton } from "./styles";
import { useMutation } from "react-query";
import axios from "axios";
import { useModalContext } from "components/modal";
import { useTranslation } from 'react-i18next';
import { useSnackbarContext } from "components/snackbar";

const Con = styled.div`
	width: 100%;
`;

const StickyWrapper = styled.div`
	position: relative;
	/* Keep space for the sticky button without forcing fixed sizing */
	min-height: 3rem;
`;

const Sticky = styled.div`
	position: sticky;
	top: 0;
	z-index: 1;
	width: 100%;
	max-width: 100%;
	display: flex;
`;

const Form = styled.form`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding-top: 10px;
	padding-bottom: 10px;

	> label {
		font-weight: bold;
		padding-left: 5px;
	}

	> div {
		width: 100%;
		padding-bottom: 10px;

		> textarea {
			width: 100%;
		}
	}
`;

export default function InspectionDetails(props) {
	const { t } = useTranslation();
	const tBase = "views.vehicle_inspection.dashboard.inspection-details";
	const tr = (key) => t(`${tBase}.${key}`);

	const inspection = props.inspection;
	const { setModal } = useModalContext();
	const { showSnackbar } = useSnackbarContext(); 
	const [form, setForm] = useState({
		comments: inspection.comments,
		notes: inspection.notes,
	});

	const mutation = useMutation(
		(inspection_id) => {
			return axios.put(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/vehicle_inspection/mark_reviewed?inspection_id=${inspection_id}`
			);
		},
		{
			onSuccess: () => {
				window.location.reload();
				setModal();
			},
			onError: () => {                                    
                showSnackbar(tr("Could not mark as reviewed"));
            },
		}
	);

	const saveComments = useMutation(
		(formData) => {
			return axios.post(
				`${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/vehicle_inspection/add_description`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
		},
		{
			onError: () => {                                   
                showSnackbar(tr("Could not save comments"));
            },
		}
	);

	const unmarkMutation = useMutation(
	    (inspection_id) => {
		    return axios.put(
			    `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/vehicle_inspection/mark_not_reviewed?inspection_id=${inspection_id}`
		  );
	    },
	    {
		    onSuccess: () => {
				window.location.reload();
				setModal();
		    },
		    onError: () => {                                         
                showSnackbar(tr("Could not move to not reviewed"));
            },	
	    }
    );

	const updateForm = (textarea) => {
		const target = textarea.target;
		const value = target.value;
		const name = target.name;

		setForm((state) => {
			const tempForm = { ...state };
			tempForm[name] = value;
			return tempForm;
		});
	};

	const handleSave = () => {
		const submitValues = { ...form, inspection_id: inspection.inspection_id };
		const formData = new FormData();
		formData.append("form", JSON.stringify(submitValues));

		saveComments.mutate(formData, {
			onSuccess: () => {
				window.location.reload();
				setModal();
			}
		});
	};

    const handleMarkReviewed = () => {
		const submitValues = { ...form, inspection_id: inspection.inspection_id };
		const formData = new FormData();
		formData.append("form", JSON.stringify(submitValues));

		saveComments.mutate(formData, {
			onSuccess: () => {
				mutation.mutate(inspection.inspection_id);
			}
		});
	};

	return (
		<Con>
			{!inspection.is_reviewed && (
				<StickyWrapper>
					<Sticky>
						<ReviewButton
							type="button"
							primary
							onClick={handleMarkReviewed}
						>
							{tr("Mark as Reviewed")}
						</ReviewButton>
					</Sticky>
				</StickyWrapper>
			)}
			{inspection.is_reviewed && (
				<StickyWrapper>
					<Sticky>
						<ReviewButton
							type="button"
							primary
							onClick={() => {
								unmarkMutation.mutate(inspection.inspection_id);
							}}
						>
							{tr("Move to Not Reviewed")}
						</ReviewButton>
					</Sticky>
				</StickyWrapper>
			)}
			<Form onSubmit={(e) => e.preventDefault()}>
				<label>{tr("Comments")}</label>
				<div>
					<TextArea
						name="comments"
						value={form.comments}
						onChange={updateForm}
						disabled={inspection.is_reviewed}
					/>
				</div>

				<label>{tr("Maintenance Notes")}</label>
				<div>
					<TextArea
						name="notes"
						value={form.notes}
						onChange={updateForm}
						disabled={inspection.is_reviewed}
					/>
				</div>

				{!inspection.is_reviewed && (
					<SubmitButton
						type="button"
						primary
						onClick={handleSave}
					>
						{tr("Save")}
					</SubmitButton>
				)}
			</Form>

			<DetailsTable inspection={inspection} />
		</Con>
	);
}